<!-- Audi Cookie Notice-->
<div class="cookie-notice-container" [hidden]="!isCookieBannerVisible">
    <div style="margin:auto;max-width:1400px;padding-left:25px;padding-right:25px;">
        <br />
        <p style="font-weight:bold;font-size:1rem;">Cookies</p>
        <p style="font-size:0.9rem;">We use cookies to make our website work better and improve your online experience. By continuing to browse this website you accept the use
            of cookies, read more about cookies and our policy.</p>
        <div style="display:inline-flex;justify-content:flex-start;width:100%;">
            <a href="javascript:void(0);" (click)="onCloseCookieBanner(null)">OK &gt;</a>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <a href="javascript:void(0);" (click)="onCloseCookieBanner('https://www.audi.co.za/za/web/en/privacy-statement.html')">Privacy Policy &gt;</a>
        </div>
        <br /><br />
    </div>
</div>

<!--main app content-->
<router-outlet></router-outlet>